import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import useGuardianDashboardService, {
  GuardianDashboardData,
} from '../../../../apis/guardian/sub-apis/useGuardianDashboardService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getGuardianDashboardKey = 'get-guardian-dashboard';

export const useGuardianDashboardHook = (
  studentId: string,
  params: TPaginationParams,
  options?: UseQueryOptions<GuardianDashboardData, TQueryError>
): UseQueryResult<GuardianDashboardData, TQueryError> => {
  const { getDashboardData } = useGuardianDashboardService();

  const safeParams = { page: params.page ?? 1, limit: params.limit ?? 10 };
  return useQuery<GuardianDashboardData, TQueryError>({
    queryKey: [getGuardianDashboardKey, studentId, safeParams],
    queryFn: () => getDashboardData(studentId, safeParams),
    enabled: !!studentId,
    ...options,
  });
};
